import {useState} from "react";
import {downloadDocumentFromUrl} from "util/downloadDocumentFromUrl";
import {getFileExtensionFromFileName} from "util/getFileExtensionFromFileName";

const supportedImagePreview = ["jpg", "png", "jpeg"];

export type PreviewFile = {
  name: string;
  url: string;
  id?: string;
  guid?: string;
};

const useEmailFilesPreview = () => {
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileId, setFileId] = useState("");
  const [fileGuid, setFileGuid] = useState("");

  const downloadFile = (url: string, name: string) => {
    try {
      downloadDocumentFromUrl(url, name);
    } catch (e) {
      console.error("Erro no download do arquivo.", e);
    }
  };

  const handleClickFileChip = (item: PreviewFile) => {
    const fileExtension = getFileExtensionFromFileName(item?.name);

    //Se o arquivo for do HC, ele precisa ser baixado diretamente, um dos casos que faz com que isso seja necessário é o arquivo
    //IPPC.pdf que vem diretamente do HC.
    if (item?.url?.includes("headcargo")) {
      downloadFile(item?.url, item?.name);
      return;
    }

    if (
      fileExtension === "pdf" ||
      supportedImagePreview.includes(fileExtension)
    ) {
      setFileUrl(item.url);
      setFileName(item.name);
      setFileId(item.id ?? "");
      setFileGuid(item.guid ?? "");
      return;
    }

    downloadFile(item?.url, item?.name);
  };

  return {
    fileUrl,
    setFileUrl,
    fileName,
    setFileName,
    fileId,
    setFileId,
    fileGuid,
    setFileGuid,
    handleClickFileChip,
    supportedImagePreview,
  };
};

export default useEmailFilesPreview;
